if (!customElements.get('email-sms-signup')) {
  customElements.define('email-sms-signup', class EmailSMSSignup extends HTMLElement {
    constructor() {
      super();
      this.props = {
        signupType: this.dataset.signupType,
        cryptoSecret: this.dataset.cryptoSecret,
        pskey: JSON.parse(this.dataset.pskey)
      };
      this.dom = {
        submitButton: this.querySelector('form'),
        signupInput: this.querySelector('[data-signup-input]'),
        successM: this.querySelector('[data-success-message]'),
        errorM: this.querySelector('[data-error-message]'),
        textsThirdlove: this.querySelector('[data-texts-thirdlove]')
      }
      this.dom.submitButton.addEventListener('submit', (e) => {
        e.preventDefault();
        this.subscribe();
      });
      if (this.dom.textsThirdlove) {
        this.dom.textsThirdlove.addEventListener('change', () => {
          this.updateCheckboxes();
        });
      }
      if (this.dom.textsKit) {
        this.dom.textsKit.addEventListener('change', () => {
          this.updateCheckboxes();
        });
      }
    }
    // Add or remove required attribute (at least )
    updateCheckboxes() {
      if (this.dom.textsThirdlove.checked || this.dom.textsKit.checked) {
        this.dom.textsThirdlove.removeAttribute('required');
        this.dom.textsKit.removeAttribute('required');
      } else {
        this.dom.textsThirdlove.setAttribute('required');
        this.dom.textsKit.setAttribute('required');
      }
    }
    subscribe() {
      let body = {
        "user-locale": window.Shopify.country === 'US' ? 'en-us' : 'en-ca'
      };
      if (this.props.signupType === 'email') {
        body.email = this.dom.signupInput.value.toString();
        // Identify user on Klaviyo
        window.klaviyoIdentify && window.klaviyoIdentify(body.email);
      } else {
        body.phone = this.dom.signupInput.value.toString();
      }
      fetch(this.props.pskey.disServiceUrl + '/v1/frontend/retail/signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': this.props.pskey.disServiceKey
        },
        body: JSON.stringify(body)
      }).then(response => {
        if (response.ok) {
          const cipherInstance = browserCrypto.createCipher(
            'aes-256-cbc',
            this.props.cryptoSecret,
          );
          const encryptedInput = cipherInstance.update(this.dom.signupInput.value.toString(), 'utf8', 'hex');
          const finalInputHash = encryptedInput + cipherInstance.final('hex');
          let data;
          this.dom.successM.classList.remove('hidden');
          this.dom.errorM.classList.add('hidden');
          if (this.props.signupType === 'email') {
            data = {
              event: 'email_subscribe',
              email: finalInputHash,
              source: 'email_sms_signup'
            }
          } else {
            data = {
              event: 'sms_subscribe',
              customer_phone: finalInputHash,
              source: 'email_sms_signup'
            }
          }
          window.sendGTMData && window.sendGTMData(data);
          return true;
        } else {
          return Promise.reject(response);
        }
      }).catch(error => {
        console.error('Unable to subscribe. ', error);
        this.dom.successM.classList.add('hidden');
        this.dom.errorM.classList.remove('hidden');
      });
    }
  });
}
